// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
export const deviceEventId = (z.number());
export const deviceEvent = z.object({
    id: deviceEventId,
    device_id: z.string(),
    event_type: z.string(),
    payload: z.unknown().nullable(),
    created_at: z.date(),
});
export const deviceEventInitializer = z.object({
    id: deviceEventId.optional(),
    device_id: z.string(),
    event_type: z.string(),
    payload: z.unknown().optional().nullable(),
    created_at: z.date().optional(),
});
export const deviceEventMutator = z.object({
    id: deviceEventId.optional(),
    device_id: z.string().optional(),
    event_type: z.string().optional(),
    payload: z.unknown().optional().nullable(),
    created_at: z.date().optional(),
});
//# sourceMappingURL=DeviceEvent.js.map